/**
 * CXOne popup postMessage helpers for parent window
 */
import { CXONE_MESSAGE_TYPES, CXONE_ALLOWED_MESSAGE_ORIGINS } from '@/constants/cxone'
import { isValidMessageOrigin } from '@/utils/postMessage'

/**
 * Returns CXOne message type if origin is valid and event is a CXOne auth message.
 * @param {MessageEvent} event - window message event
 * @param {string} currentOrigin - window.location.origin of the parent
 * @returns {'success'|'error'|null} - 'success' | 'error' | null
 */
export function getCXOneMessageType (event, currentOrigin) {
  if (!isValidMessageOrigin(event.origin, currentOrigin, CXONE_ALLOWED_MESSAGE_ORIGINS)) {
    return null
  }
  if (event.data?.type === CXONE_MESSAGE_TYPES.SUCCESS) return 'success'
  if (event.data?.type === CXONE_MESSAGE_TYPES.ERROR) return 'error'
  return null
}
